import { metrics } from '../metrics/index';

let ignoredActions = ['redux-form'];
const objectToTags = (obj) =>
  Object.keys(obj)
    .filter((key) => key !== 'count')
    .map((key) => `${key}:${obj[key]}`);

const selectAction = (type) =>
  !ignoredActions.some((ignoredAction) => type.indexOf(ignoredAction) > -1);

const addIgnoredActions = (actions) => {
  if (actions) {
    ignoredActions = ignoredActions.concat(actions);
  }
};

export const reduxActionMetrics = ({
  ignoredActions: newIgnoredActions,
} = {}) => {
  addIgnoredActions(newIgnoredActions);

  return () => (next) => (action) => {
    const { type, meta } = action;

    if (type && selectAction(type)) {
      const extraTags = meta && meta.metrics ? objectToTags(meta.metrics) : [];
      const count = meta && meta.metrics ? meta.metrics.count : null;

      metrics.count('actions', [`action-name:${type}`, ...extraTags], count);
    }

    return next(action);
  };
};



// WEBPACK FOOTER //
// ./src/middleware/redux.js